import React from "react";
import { motion } from "framer-motion";

const ProductSkeleton = ({ grid = 3 }) => {
  const skeletonItems = Array.from({ length: 12 }, (_, index) => index);

  return (
    <div
      className={`grid ${
        grid === 1
          ? "grid-cols-1"
          : "grid-cols-1 md600:grid-cols-2 3xl:grid-cols-3"
      } gap-4 xl:gap-8 relative z-10`}
    >
      {skeletonItems.map((index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className={`group relative bg-white/5 backdrop-blur-xl rounded-xl lg:rounded-3xl overflow-hidden border border-white/10 ${
            grid === 1 ? "md:flex" : ""
          }`}
        >
          {/* Image Container Skeleton */}
          <div
            className={`relative overflow-hidden ${
              grid === 1
                ? "w-full md:w-60 lg:w-64 md:h-full"
                : "h-48"
            }`}
          >
            <div className="w-full h-full bg-gradient-to-br from-gray-700/50 to-gray-800/50 animate-pulse"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
            
            {/* Badge Skeleton */}
            <div className="absolute top-4 left-4">
              <div className="w-12 h-6 bg-gray-600/50 rounded-full animate-pulse"></div>
            </div>

            {/* Action Button Skeleton */}
            <div className="absolute top-4 right-4">
              <div className="w-8 h-8 bg-gray-600/50 rounded-full animate-pulse"></div>
            </div>
          </div>

          {/* Content Skeleton */}
          <div className={`p-3 xl:p-6 ${grid === 1 ? "md:flex-1" : ""}`}>
            {/* Title Skeleton */}
            <div className="mb-2">
              <div className="h-6 bg-gray-600/50 rounded animate-pulse mb-2"></div>
              <div className="h-4 bg-gray-600/50 rounded w-3/4 animate-pulse"></div>
            </div>

            {/* Description Skeleton */}
            <div className="mb-4 space-y-2">
              <div className="h-3 bg-gray-600/50 rounded animate-pulse"></div>
              <div className="h-3 bg-gray-600/50 rounded w-5/6 animate-pulse"></div>
              <div className="h-3 bg-gray-600/50 rounded w-4/6 animate-pulse"></div>
            </div>

            {/* Platforms Skeleton */}
            <div className="mt-4">
              <div className="h-5 bg-gray-600/50 rounded w-24 mb-2 animate-pulse"></div>
              <div className="flex gap-4">
                <div className="w-6 h-6 bg-gray-600/50 rounded animate-pulse"></div>
                <div className="w-6 h-6 bg-gray-600/50 rounded animate-pulse"></div>
                <div className="w-6 h-6 bg-gray-600/50 rounded animate-pulse"></div>
              </div>
            </div>

            {/* Price and CTA Skeleton */}
            <div className="flex items-center md:items-start lg:items-center justify-between flex-row md:flex-col lg:flex-row mt-4">
              <div className="space-y-2">
                <div className="h-4 bg-gray-600/50 rounded w-20 animate-pulse"></div>
                <div className="h-4 bg-gray-600/50 rounded w-16 animate-pulse"></div>
              </div>
              <div className="w-24 h-8 bg-gray-600/50 rounded-md animate-pulse mt-2 md:mt-0"></div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default ProductSkeleton;
